(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ewg-3d-spotlight"] && !Shopify.designMode) return;
  try {
    
 const ewgModels = document.querySelectorAll('.ewg-3d-spotlight model-viewer');
 if (ewgModels.length && window.Shopify?.loadFeatures) {
   window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors=>{if(errors)return;ewgModels.forEach(model=>{new window.Shopify.ModelViewerUI(model);});}}]);
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewg-finish-guide"] && !Shopify.designMode) return;
  try {
    
 document.querySelectorAll('.ewg-finishes').forEach(section=>{section.querySelectorAll('[data-finish-filter]').forEach(button=>button.addEventListener('click',()=>{const group=button.dataset.finishFilter;section.querySelectorAll('[data-finish-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));section.querySelectorAll('[data-finish-family]').forEach(card=>{card.hidden=group!=='all'&&!card.dataset.finishFamily.split(' ').includes(group);});}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ewg-page"] && !Shopify.designMode) return;
  try {
    
  const ewgProductField = document.getElementById('EWGProduct');
  if (ewgProductField && !ewgProductField.value) {
    ewgProductField.value = new URLSearchParams(window.location.search).get('product') || '';
  }
  const ewgFinishField = document.getElementById('EWGFinish');
  if (ewgFinishField && !ewgFinishField.value) ewgFinishField.value = new URLSearchParams(window.location.search).get('finish') || '';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
